import React, { useEffect } from "react";
import SalesAmountCard from "./components/SalesAmountCard";
import Charts from "./components/Charts";
import AppContext from "../context";
import { getCookieByName, setCookieByName } from "../../../utils";

import Page from "../../../_components/Layout/Page";
import Row from "../../../_components/Layout/Row";
import Column from "../../../_components/Layout/Column";
import Text from "../../../_components/Text";
import Dialog from "../../Fiscal/NFe/Issuer/Dialog";
// import AnnouncementsCard from "./components/AnnouncementsCard";
export default (props) => {
  const context = React.useContext(AppContext);
  const [freeFinancial, setFreeFinancial] = React.useState(false)
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (context.currentBranch && context.currentBranch.branch_plan) {
      const { plan, start_date, end_date } = context.currentBranch.branch_plan;
  
      if (plan !== 'a4366037-9adc-47eb-a3d8-66d2b7699032' && plan !== '89723c2c-64d1-40b4-9806-1aa433f91645' && plan !== 'f1818dc9-f799-4ad0-9dc1-37c33ce55265') {
        const startDate = new Date(start_date);
        const endDate = new Date(end_date);
        const isAnualPlan = (endDate.getFullYear() - startDate.getFullYear() === 1) &&
          (endDate.getMonth() === startDate.getMonth()) &&
          (endDate.getDate() === startDate.getDate());
  
        if (!isAnualPlan) {
          setFreeFinancial(true);
        }
      }
    }
  }, [context.currentBranch]);


  function shouldShowPopup() {
    const hasSeenPopup = getCookieByName('hasSeenPopup');
    return hasSeenPopup !== 'true'; 
  }


  return (
    <Page>
      <SalesAmountCard />
      <Row>
        <Column col="12">
          <Text align="center" fontSize="1.3em" className="py-4">Veja suas últimas vendas clicando  <a href="/sales/report">aqui</a></Text>
        </Column>
      </Row>
      <Charts />
     {// <AnnouncementsCard/>
}
      {shouldShowPopup() &&
        <Dialog show={freeFinancial} onHide={()=>{
        setFreeFinancial(false)
        setCookieByName('hasSeenPopup', 'true');}} 
        type="info">

          <h1>Temos Novidades!</h1>
            
          <h2>Agora o módulo financeiro está <b className="fw-bold">100% liberado</b> para clientes com qualquer mensalidade <b className="tw-bold">ativa.</b></h2>
          <h2><a href='/financial/home'>Clique aqui</a> para <b className="fw-bold">começar a aproveitar</b> todas as funcionalidades. Qualquer dúvida, entre em contato com nosso <a href="https://api.whatsapp.com/send/?phone=5511966466526&text&app_absent=0" className="text-decoration-underline">suporte técnico</a> via whatsapp.</h2>
        </Dialog>
      }
    </Page>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Dashboard/index.jsx